import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoContracts = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--background-complete--inject-40",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					y: 382.4,
					width: 500,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 416.78,
					y: 398.49,
					width: 33.12,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 322.53,
					y: 401.21,
					width: 8.69,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 396.59,
					y: 389.21,
					width: 19.19,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 52.46,
					y: 390.89,
					width: 43.19,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 104.56,
					y: 390.89,
					width: 6.33,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 131.47,
					y: 395.11,
					width: 93.68,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 120.76,
					y: 106.14,
					width: 256.03,
					height: 211.4,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 120.76,
					y: 110.62,
					width: 251.92,
					height: 202.62,
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "370.81 255.59 370.81 184.01 363.38 184.01 363.38 174.55 346.64 166.72 346.64 157.04 343.85 157.04 343.85 184.01 341.06 184.01 341.06 255.59 337.35 255.59 337.35 218.41 328.98 218.41 328.98 198.88 326.19 198.88 326.19 255.59 319.68 255.59 319.68 234.21 315.03 234.21 315.03 228.63 304.81 228.63 304.81 209.11 299.23 209.11 299.23 196.09 292.72 196.09 292.72 176.57 289.93 176.57 289.93 196.09 283.42 196.09 283.42 209.11 277.85 209.11 277.85 228.63 267.62 228.63 267.62 234.21 262.97 234.21 262.97 255.59 257.39 255.59 257.39 228.63 247.16 228.63 247.16 169.13 244.38 169.13 244.38 162.62 222.06 162.62 222.06 169.13 217.41 169.13 217.41 211.9 198.82 211.9 198.82 216.55 192.31 216.55 192.31 219.34 198.82 219.34 198.82 236.07 179.3 236.07 179.3 180.29 175.58 180.29 175.58 169.13 166.28 169.13 166.28 126.36 163.49 126.36 163.49 169.13 156.98 169.13 156.98 180.29 120.76 180.29 120.76 313.24 372.67 313.24 372.67 255.59 370.81 255.59",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 140.11,
					y: 183.2,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 140.11,
					y: 187.62,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 140.11,
					y: 205.28,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 140.11,
					y: 209.7,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 140.11,
					y: 214.11,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 140.11,
					y: 227.36,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 140.11,
					y: 231.78,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 144.3,
					y: 200.87,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 144.3,
					y: 205.28,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 144.3,
					y: 209.7,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 144.3,
					y: 214.11,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 144.3,
					y: 218.53,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 144.3,
					y: 227.36,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 144.3,
					y: 231.78,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 148.48,
					y: 183.2,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 148.48,
					y: 187.62,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 148.48,
					y: 192.03,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 148.48,
					y: 196.45,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 148.48,
					y: 200.87,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 148.48,
					y: 205.28,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 148.48,
					y: 209.7,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 148.48,
					y: 214.11,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 148.48,
					y: 218.53,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 148.48,
					y: 222.95,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 148.48,
					y: 231.78,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 152.66,
					y: 183.2,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 152.66,
					y: 187.62,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 152.66,
					y: 192.03,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 152.66,
					y: 196.45,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 152.66,
					y: 200.87,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 152.66,
					y: 205.28,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 152.66,
					y: 209.7,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 152.66,
					y: 249.44,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 156.85,
					y: 183.2,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 156.85,
					y: 187.62,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 156.85,
					y: 192.03,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 156.85,
					y: 196.45,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 156.85,
					y: 200.87,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 156.85,
					y: 205.28,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 156.85,
					y: 209.7,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 156.85,
					y: 214.11,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 156.85,
					y: 240.61,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 156.85,
					y: 245.03,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 156.85,
					y: 249.44,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 156.85,
					y: 253.86,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 156.85,
					y: 271.52,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 183.2,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 187.62,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 192.03,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 196.45,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 200.87,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 205.28,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 209.7,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 214.11,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 218.53,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 222.95,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 236.2,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 240.61,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 245.03,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 249.44,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 253.86,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 161.03,
					y: 271.52,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 183.2,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 187.62,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 192.03,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 196.45,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 200.87,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 205.28,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 209.7,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 214.11,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 218.53,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 222.95,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 227.36,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 231.78,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 236.2,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 240.61,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 245.03,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 249.44,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 253.86,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 165.22,
					y: 258.28,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 169.4,
					y: 183.2,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 169.4,
					y: 187.62,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 169.4,
					y: 192.03,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 169.4,
					y: 196.45,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 169.4,
					y: 200.87,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 169.4,
					y: 205.28,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 169.4,
					y: 209.7,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 169.4,
					y: 214.11,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 169.4,
					y: 218.53,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 169.4,
					y: 222.95,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 169.4,
					y: 236.2,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 169.4,
					y: 240.61,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 169.4,
					y: 245.03,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 169.4,
					y: 249.44,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 173.58,
					y: 183.2,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 173.58,
					y: 187.62,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 173.58,
					y: 192.03,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 173.58,
					y: 196.45,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 173.58,
					y: 200.87,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 173.58,
					y: 205.28,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 173.58,
					y: 209.7,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 173.58,
					y: 214.11,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 173.58,
					y: 218.53,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 173.58,
					y: 222.95,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 173.58,
					y: 236.2,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 173.58,
					y: 240.61,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 173.58,
					y: 245.03,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 220.69,
					y: 171.74,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 220.69,
					y: 176.15,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 220.69,
					y: 180.57,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 220.69,
					y: 184.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 220.69,
					y: 189.4,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 220.69,
					y: 193.82,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 220.69,
					y: 198.23,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 220.69,
					y: 202.65,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 220.69,
					y: 215.9,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 220.69,
					y: 220.31,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 224.87,
					y: 171.74,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 224.87,
					y: 176.15,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 224.87,
					y: 180.57,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 224.87,
					y: 184.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 224.87,
					y: 189.4,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 224.87,
					y: 193.82,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 224.87,
					y: 198.23,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 224.87,
					y: 202.65,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 224.87,
					y: 220.31,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 229.06,
					y: 171.74,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 229.06,
					y: 176.15,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 229.06,
					y: 180.57,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 229.06,
					y: 184.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 229.06,
					y: 189.4,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 229.06,
					y: 193.82,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 229.06,
					y: 198.23,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 229.06,
					y: 202.65,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 171.74,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 176.15,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 180.57,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 184.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 189.4,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 193.82,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 202.65,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 207.06,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 220.31,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 224.73,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 229.15,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 233.56,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 237.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 242.39,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 233.24,
					y: 246.81,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 171.74,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 176.15,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 180.57,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 184.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 189.4,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 193.82,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 207.06,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 211.48,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 215.9,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 220.31,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 224.73,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 229.15,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 233.56,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 237.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 242.39,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 246.81,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 251.23,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 237.42,
					y: 260.06,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 171.74,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 176.15,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 180.57,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 184.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 189.4,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 193.82,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 207.06,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 211.48,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 215.9,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 220.31,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 233.56,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 237.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 242.39,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 246.81,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 251.23,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 260.06,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.61,
					y: 264.47,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 279.57,
					y: 212.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 279.57,
					y: 217.21,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 279.57,
					y: 221.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 279.57,
					y: 226.05,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 279.57,
					y: 230.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 279.57,
					y: 234.88,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 279.57,
					y: 239.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 279.57,
					y: 252.54,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 279.57,
					y: 256.96,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 279.57,
					y: 261.37,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 283.75,
					y: 212.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 283.75,
					y: 217.21,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 283.75,
					y: 221.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 283.75,
					y: 226.05,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 283.75,
					y: 230.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 283.75,
					y: 234.88,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 283.75,
					y: 239.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 287.94,
					y: 212.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 287.94,
					y: 217.21,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 287.94,
					y: 221.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 287.94,
					y: 226.05,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 287.94,
					y: 230.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 287.94,
					y: 234.88,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 287.94,
					y: 239.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 292.12,
					y: 212.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 292.12,
					y: 217.21,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 292.12,
					y: 221.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 292.12,
					y: 226.05,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 292.12,
					y: 230.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 292.12,
					y: 234.88,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 292.12,
					y: 239.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 292.12,
					y: 243.71,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 292.12,
					y: 248.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 292.12,
					y: 252.54,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 292.12,
					y: 256.96,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 296.3,
					y: 212.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 296.3,
					y: 217.21,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 296.3,
					y: 221.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 296.3,
					y: 226.05,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 296.3,
					y: 230.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 296.3,
					y: 234.88,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 296.3,
					y: 239.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 296.3,
					y: 243.71,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 296.3,
					y: 248.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 296.3,
					y: 252.54,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 296.3,
					y: 256.96,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 296.3,
					y: 261.37,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 296.3,
					y: 274.62,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 296.3,
					y: 279.04,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 300.49,
					y: 212.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 300.49,
					y: 217.21,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 300.49,
					y: 221.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 300.49,
					y: 234.88,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 300.49,
					y: 239.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 300.49,
					y: 243.71,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 300.49,
					y: 248.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 300.49,
					y: 252.54,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 300.49,
					y: 256.96,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 300.49,
					y: 261.37,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 300.49,
					y: 274.62,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 300.49,
					y: 279.04,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 300.49,
					y: 283.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 186.3,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 190.72,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 195.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 199.55,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 203.97,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 208.38,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 212.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 217.21,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 221.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 226.05,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 230.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 234.88,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 239.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 243.71,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 248.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 252.54,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 256.96,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 261.37,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 265.79,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 270.21,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 274.62,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 279.04,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 344.34,
					y: 283.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 186.3,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 190.72,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 195.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 199.55,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 203.97,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 208.38,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 212.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 217.21,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 221.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 226.05,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 230.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 234.88,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 239.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 243.71,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 248.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 252.54,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 256.96,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 261.37,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 348.52,
					y: 265.79,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 186.3,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 190.72,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 195.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 199.55,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 203.97,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 208.38,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 212.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 217.21,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 221.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 226.05,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 230.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 234.88,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 239.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 243.71,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 248.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 252.54,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 256.96,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 261.37,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 352.71,
					y: 265.79,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 186.3,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 190.72,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 195.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 199.55,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 203.97,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 208.38,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 212.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 217.21,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 221.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 226.05,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 230.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 234.88,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 239.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 243.71,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 356.89,
					y: 248.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 361.07,
					y: 186.3,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 361.07,
					y: 190.72,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 361.07,
					y: 195.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 361.07,
					y: 199.55,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 361.07,
					y: 203.97,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 361.07,
					y: 208.38,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 361.07,
					y: 212.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 361.07,
					y: 217.21,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 361.07,
					y: 221.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 361.07,
					y: 226.05,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 361.07,
					y: 230.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 361.07,
					y: 234.88,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 361.07,
					y: 239.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 365.26,
					y: 186.3,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 365.26,
					y: 190.72,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 365.26,
					y: 195.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 365.26,
					y: 199.55,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 365.26,
					y: 203.97,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 365.26,
					y: 208.38,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 365.26,
					y: 212.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 365.26,
					y: 217.21,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 365.26,
					y: 221.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 365.26,
					y: 226.05,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 365.26,
					y: 230.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 365.26,
					y: 234.88,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 184.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 189.4,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 193.82,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 198.23,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 202.65,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 207.06,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 211.48,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 215.9,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 220.31,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 224.73,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 229.15,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 233.56,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 237.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 242.39,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 246.81,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 251.23,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 255.64,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 264.47,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 268.89,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 273.31,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 277.72,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 121.06,
					y: 282.14,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 184.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 189.4,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 193.82,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 198.23,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 202.65,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 207.06,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 211.48,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 215.9,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 220.31,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 224.73,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 229.15,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 233.56,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 237.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 242.39,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 246.81,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 251.23,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 277.72,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 125.24,
					y: 282.14,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 184.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 189.4,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 193.82,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 198.23,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 202.65,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 207.06,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 211.48,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 215.9,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 220.31,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 224.73,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 229.15,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 233.56,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 237.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 242.39,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 246.81,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 251.23,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 260.06,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 264.47,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 268.89,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 273.31,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 129.42,
					y: 282.14,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 215.9,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 220.31,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 224.73,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 229.15,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 233.56,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 237.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 242.39,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 246.81,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 251.23,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 255.64,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 260.06,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 264.47,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 268.89,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 277.72,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 282.14,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 286.55,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 290.97,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 299.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 304.22,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 202.4,
					y: 308.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 215.9,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 220.31,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 224.73,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 229.15,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 233.56,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 237.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 242.39,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 246.81,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 251.23,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 255.64,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 260.06,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 264.47,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 268.89,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 282.14,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 286.55,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 295.39,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 299.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 304.22,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 206.59,
					y: 308.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 215.9,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 220.31,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 224.73,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 229.15,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 233.56,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 237.98,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 242.39,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 246.81,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 251.23,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 255.64,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 260.06,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 264.47,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 268.89,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 273.31,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 282.14,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 290.97,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 295.39,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 299.8,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 304.22,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 210.77,
					y: 308.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 185.36,
					y: 241.08,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 185.36,
					y: 245.49,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 185.36,
					y: 249.91,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 185.36,
					y: 254.32,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 185.36,
					y: 258.74,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 185.36,
					y: 263.16,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 185.36,
					y: 276.4,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 185.36,
					y: 280.82,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 185.36,
					y: 285.24,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 185.36,
					y: 289.65,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 185.36,
					y: 294.07,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 185.36,
					y: 298.49,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 185.36,
					y: 302.9,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 189.54,
					y: 241.08,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 189.54,
					y: 245.49,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 189.54,
					y: 249.91,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 189.54,
					y: 254.32,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 189.54,
					y: 258.74,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 189.54,
					y: 263.16,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 189.54,
					y: 276.4,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 189.54,
					y: 280.82,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 189.54,
					y: 285.24,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 189.54,
					y: 289.65,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 189.54,
					y: 294.07,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 189.54,
					y: 298.49,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 189.54,
					y: 307.32,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 221.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 226.05,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 230.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 234.88,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 239.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 243.71,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 248.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 252.54,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 256.96,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 261.37,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 265.79,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 274.62,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 279.04,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 283.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 287.87,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 292.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 296.7,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 301.12,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 328.53,
					y: 305.54,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 221.63,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 226.05,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 230.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 234.88,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 239.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 243.71,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 248.13,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 252.54,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 256.96,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 261.37,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 265.79,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 270.21,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 274.62,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 279.04,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 283.46,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 287.87,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 292.29,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 296.7,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 301.12,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 332.72,
					y: 305.54,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 307.92,
					y: 238.83,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 307.92,
					y: 243.25,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 307.92,
					y: 247.66,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 307.92,
					y: 252.08,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 307.92,
					y: 256.49,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 307.92,
					y: 260.91,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 307.92,
					y: 265.33,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 307.92,
					y: 269.74,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 307.92,
					y: 274.16,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 307.92,
					y: 278.57,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 312.11,
					y: 238.83,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 312.11,
					y: 243.25,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 312.11,
					y: 247.66,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 312.11,
					y: 252.08,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 312.11,
					y: 256.49,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 312.11,
					y: 260.91,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 312.11,
					y: 265.33,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 312.11,
					y: 269.74,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 312.11,
					y: 274.16,
					width: 2.63,
					height: 2.63,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 287.22,
					y: 106.63,
					width: 4.42,
					height: 210.91,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 204.05,
					y: 106.63,
					width: 4.42,
					height: 210.91,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 120.88,
					y: 106.63,
					width: 4.42,
					height: 210.91,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M237.6,290.56H224.11v-.9c0-1.76,2-3.16,4.33-3.07l5.28.22c2.17.08,3.88,1.43,3.88,3.06Z",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M205.66,266.11a1.74,1.74,0,0,0-1.74-1.67H192a1.74,1.74,0,0,0-1.74,1.67L193.05,291H210.9Z",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M238.13,227.81h-4.46l-5,47h4.45a1.52,1.52,0,0,0,1.48-1.33l4.72-44.38A1.17,1.17,0,0,0,238.13,227.81Z",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M231.24,274.85H164.48a1.17,1.17,0,0,1-1.19-1.33L168,229.14a1.52,1.52,0,0,1,1.48-1.33h66.75a1.18,1.18,0,0,1,1.2,1.33l-4.72,44.38A1.52,1.52,0,0,1,231.24,274.85Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M230,270.51H167a1,1,0,0,1-1-1.17l4.12-38.71a1.32,1.32,0,0,1,1.29-1.17h63a1,1,0,0,1,1,1.17l-4.12,38.71A1.32,1.32,0,0,1,230,270.51Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 188.65,
					y: 289.08,
					width: 23.88,
					height: 1.93,
					rx: .96,
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 211.27,
					y: 290.46,
					width: 54.35,
					height: 8.2,
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M114.18,382h-1.36a.3.3,0,0,1-.31-.3l-2.14-83.06h6.26l-2.14,83.06A.3.3,0,0,1,114.18,382Z",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "65.81 382.02 62.67 382.02 71.52 298.66 77.79 298.66 65.81 382.02",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "267.73 382.02 267.73 382.02 255.72 298.66 261.99 298.66 270.83 382.02 267.73 382.02",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 67.9,
					y: 290.46,
					width: 158.87,
					height: 8.2,
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "221.81 382.02 218.21 382.02 218.21 382.02 216.88 298.66 223.14 298.66 221.81 382.02",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M171.06,289h-1.67a.31.31,0,0,1-.31-.31v-1.76a.31.31,0,0,1,.31-.32h1.2a.32.32,0,0,1,.31.23l.47,1.76A.32.32,0,0,1,171.06,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M173.36,289h-1.67a.31.31,0,0,1-.31-.31v-1.76a.31.31,0,0,1,.31-.32h1.2a.32.32,0,0,1,.31.23l.47,1.76A.32.32,0,0,1,173.36,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M175.66,289H174a.31.31,0,0,1-.32-.31v-1.76a.32.32,0,0,1,.32-.32h1.19a.32.32,0,0,1,.31.23l.47,1.76A.32.32,0,0,1,175.66,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M178,289H176.3a.31.31,0,0,1-.32-.31v-1.76a.32.32,0,0,1,.32-.32h1.19a.31.31,0,0,1,.31.23l.47,1.76A.32.32,0,0,1,178,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M180.26,289H178.6a.31.31,0,0,1-.32-.31v-1.76a.32.32,0,0,1,.32-.32h1.19a.31.31,0,0,1,.31.23l.47,1.76A.32.32,0,0,1,180.26,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M182.56,289H180.9a.31.31,0,0,1-.32-.31v-1.76a.32.32,0,0,1,.32-.32h1.19a.31.31,0,0,1,.31.23l.47,1.76A.32.32,0,0,1,182.56,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M184.86,289H183.2a.31.31,0,0,1-.32-.31v-1.76a.32.32,0,0,1,.32-.32h1.19a.31.31,0,0,1,.31.23l.47,1.76A.32.32,0,0,1,184.86,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M187.16,289H185.5a.31.31,0,0,1-.32-.31v-1.76a.32.32,0,0,1,.32-.32h1.19a.31.31,0,0,1,.31.23l.47,1.76A.32.32,0,0,1,187.16,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M189.46,289H187.8a.31.31,0,0,1-.32-.31v-1.76a.32.32,0,0,1,.32-.32H189a.31.31,0,0,1,.31.23l.47,1.76A.32.32,0,0,1,189.46,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M191.76,289H190.1a.31.31,0,0,1-.32-.31v-1.76a.32.32,0,0,1,.32-.32h1.2a.3.3,0,0,1,.3.23l.47,1.76A.31.31,0,0,1,191.76,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M194.07,289H192.4a.31.31,0,0,1-.32-.31v-1.76a.32.32,0,0,1,.32-.32h1.2a.3.3,0,0,1,.3.23l.47,1.76A.31.31,0,0,1,194.07,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M196.37,289H194.7a.32.32,0,0,1-.32-.31v-1.76a.32.32,0,0,1,.32-.32h1.2a.3.3,0,0,1,.3.23l.47,1.76A.31.31,0,0,1,196.37,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M198.67,289H197a.32.32,0,0,1-.32-.31v-1.76a.32.32,0,0,1,.32-.32h1.2a.3.3,0,0,1,.3.23l.47,1.76A.31.31,0,0,1,198.67,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M201,289H199.3a.32.32,0,0,1-.32-.31v-1.76a.32.32,0,0,1,.32-.32h1.2a.3.3,0,0,1,.3.23l.47,1.76A.31.31,0,0,1,201,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M203.27,289H201.6a.32.32,0,0,1-.32-.31v-1.76a.32.32,0,0,1,.32-.32h1.2a.32.32,0,0,1,.31.23l.46,1.76A.31.31,0,0,1,203.27,289Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 167.72,
					y: 287.79,
					width: 37.22,
					height: 2.77,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M81.63,306.15h57.56a5,5,0,0,1,5,5v3.78a0,0,0,0,1,0,0H76.63a0,0,0,0,1,0,0v-3.78A5,5,0,0,1,81.63,306.15Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M78.83,364.94l21.65-2.13V332.39h8.58V362.8l21.74,2.14a4.21,4.21,0,0,1,3.8,4.19v3.25H75v-3.25A4.21,4.21,0,0,1,78.83,364.94Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M126.7,376.41a5.61,5.61,0,1,0,5.61-5.61A5.61,5.61,0,0,0,126.7,376.41Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M82.93,376.41a5.61,5.61,0,1,1-5.61-5.61A5.61,5.61,0,0,1,82.93,376.41Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M103.14,311.83h3.27a4.13,4.13,0,0,1,4.13,4.13v23a0,0,0,0,1,0,0H99a0,0,0,0,1,0,0V316A4.13,4.13,0,0,1,103.14,311.83Z",
					transform: "translate(209.54 650.75) rotate(180)",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M116.17,306.72c-3-11.32-9.73-40.61-11.15-79.3a11.14,11.14,0,0,0-11.14-10.7h-20a11.13,11.13,0,0,0-11.14,11.09C62.69,246,64,283.19,74.22,313.42l38-1.4A4.21,4.21,0,0,0,116.17,306.72Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M110.8,311.4a392.32,392.32,0,0,1-12-82.68,10.28,10.28,0,0,0-10.27-9.87H70.15a10.28,10.28,0,0,0-10.28,10.22c-.07,16.78,1.1,54.44,10.57,82.33Z",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M102.89,284.88s21.9-4.43,43-2.29S136,312.35,136,312.35h-4.37s16.47-17.51,15.55-21.87-42.39,1.39-42.39,1.39Z",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M70.44,311.4h35.85a392.46,392.46,0,0,1-12-82.68,10.28,10.28,0,0,0-10.28-9.87H70.16a10.28,10.28,0,0,0-10.29,10.22C59.8,245.85,61,283.51,70.44,311.4Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 69.72,
					y: 310.54,
					width: 76.89,
					height: 4.39,
					rx: 2.01,
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M416.51,345.41c0-.4,1.34-39.68,7.73-45.89,6.21-6,13.34-.22,13.64,0l.65-.77c-.09-.07-8.13-6.64-15,0-6.68,6.5-8,44.94-8,46.58Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M416,353.13c0-.47,4.36-47.16-12.69-66.72l-.75.65C419.29,306.3,415,352.57,415,353Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M416.59,348.19l1-.07c0-.53-3.34-53.07,9.16-64.57l-.67-.74C413.22,294.63,416.44,346,416.59,348.19Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M415,348.16h1c0-1.44-.41-35.49-10.08-41a6.82,6.82,0,0,0-6.26-.61c-5.85,2.42-8.75,12.82-8.87,13.27l1,.26c0-.1,2.89-10.38,8.28-12.61a5.91,5.91,0,0,1,5.38.56C414.56,313.24,415,347.81,415,348.16Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M418.73,348.19l1-.06c0-.27-1.46-26.91,5.73-36.29,1.74-2.27,3.64-3.36,5.63-3.22,4.71.33,8.66,7.22,8.7,7.29l.87-.49c-.17-.3-4.25-7.43-9.5-7.8-2.34-.16-4.53,1.05-6.49,3.61C417.25,320.91,418.66,347.08,418.73,348.19Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M417.15,351.81c.2-2.59,4.7-63.4-3.23-74.12l-.8.59c7.71,10.42,3.08,72.82,3,73.45Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M397.46,312.67s4.76,1.75,3.34,5.89-16.44,10.95-16.44,10.95-6.3-5.77-.51-15.16S397.34,309.71,397.46,312.67Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M418.13,304.8s-5.06-.22-5.35,4.15,11,16.43,11,16.43,8-2.91,6.31-13.79S419.39,302.11,418.13,304.8Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M422.41,283.91s-3.37-.36-3.1-2.41,13.12-7.35,20.7,1.2c0,0-4.85,8.34-11.87,8.45S422.41,283.91,422.41,283.91Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M416.13,278.92s3.05,1.48,3.91-.41-7.25-13.17-18.21-9.92c0,0-.29,9.64,5.61,13.44S416.13,278.92,416.13,278.92Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M432.1,311s-2.33-1.88.19-2.8,14.85-.66,15,11.56c0,0-14.36,2.39-16.14-2.27S432.1,311,432.1,311Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M402.81,283.61s2.33-1.88-.18-2.8-14.85-.66-15,11.56c0,0,14.37,2.39,16.14-2.27S402.81,283.61,402.81,283.61Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M410.41,293.45s.2-2.29-1.64-1.39-8.28,7.83-1.62,14.41c0,0,9-6.64,7.36-10.1S410.41,293.45,410.41,293.45Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M434.19,296.71s-1.4-1.83.64-2S446,296.87,443.88,306c0,0-11.13-.84-11.61-4.63S434.19,296.71,434.19,296.71Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "396.57 382.02 434.77 382.02 438.89 340.2 392.45 340.2 396.57 382.02",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 390.41,
					y: 335.59,
					width: 50.52,
					height: 9.23,
					transform: "translate(831.35 680.4) rotate(180)",
					style: { fill: "#e6e6e6" }
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "freepik--Shadow--inject-40",
			children: /* @__PURE__ */ _jsx("ellipse", {
				id: "freepik--path--inject-40",
				cx: 250,
				cy: 416.24,
				rx: 193.89,
				ry: 11.32,
				style: { fill: "#f5f5f5" }
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Contract--inject-40",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M403.29,418.43H235.05a5.13,5.13,0,0,1-5.2-5.78l28.87-286.42a6.54,6.54,0,0,1,6.36-5.78H433.32a5.14,5.14,0,0,1,5.2,5.78L409.65,412.65A6.54,6.54,0,0,1,403.29,418.43Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M378.1,142.15H315.93a4.12,4.12,0,0,1-4.17-4.64l1.73-17.23a1,1,0,0,1,.92-.83H384.2a.73.73,0,0,1,.74.83l-1.73,17.23A5.26,5.26,0,0,1,378.1,142.15Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M350.1,111.57a5.26,5.26,0,0,0-5.12,4.65l-.73,7.22h9.3l.72-7.22A4.12,4.12,0,0,0,350.1,111.57Zm-.7,6.92a1.66,1.66,0,0,1-1.69-1.88,2.12,2.12,0,0,1,2.07-1.87,1.67,1.67,0,0,1,1.69,1.87A2.13,2.13,0,0,1,349.4,118.49Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M377.35,137.9H352.18a1,1,0,0,1-.72-.31,1,1,0,0,1-.28-.73,3.27,3.27,0,0,0-.87-2.38,3.2,3.2,0,0,0-2.32-.95,4.26,4.26,0,0,0-4.1,3.53,1,1,0,0,1-1,.84H317.74a1,1,0,0,1-.75-.33,1,1,0,0,1-.25-.77L318,124.33a1,1,0,0,1,1-.9H378.6a1,1,0,0,1,1,1.1L378.34,137A1,1,0,0,1,377.35,137.9Zm-24.23-2h23.32l1.06-10.47H319.9l-1.06,10.47h23.28a6.31,6.31,0,0,1,5.87-4.37,5.11,5.11,0,0,1,5.13,4.37Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M373.9,124.5a1.6,1.6,0,0,1,.79-1.36h-52a1.6,1.6,0,0,0-.79,1.36c-.11,1.08.51,1.36.51,1.36h52S373.79,125.58,373.9,124.5Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "403.85 409.68 237.08 409.68 265.35 129.19 432.12 129.19 403.85 409.68",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M418.88,158.79H272.72a.5.5,0,0,1,0-1H418.88a.5.5,0,0,1,0,1Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M291.76,145.52a9,9,0,0,1-8.73,7.93,7,7,0,0,1-7.13-7.93,9,9,0,0,1,8.73-7.93A7,7,0,0,1,291.76,145.52Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M279.32,144.33s-4.26,5.62-3,7.33,13.09-7.91,15.93-11.21-.49-2-.49-2,1.25.07.58,1.08c-1.37,2.08-12.6,9.5-13.74,9.1S279.32,144.33,279.32,144.33Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M418.64,142.86h-15a1,1,0,0,1,0-2h15a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M418.17,147.52h-9.69a1,1,0,0,1,0-2h9.69a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M417.7,152.18H392.38a1,1,0,0,1,0-2H417.7a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", { d: "M310.53,170.79a4.83,4.83,0,0,1,4.93-4.32,3.83,3.83,0,0,1,3.18,1.4l-1.1.95a2.66,2.66,0,0,0-2.15-1,3.22,3.22,0,0,0-3.29,2.95,2.55,2.55,0,0,0,2.7,3,3.25,3.25,0,0,0,2.34-1l.91,1a4.71,4.71,0,0,1-3.47,1.41A3.8,3.8,0,0,1,310.53,170.79Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M319.07,170.79a4.86,4.86,0,0,1,5-4.32,3.81,3.81,0,0,1,4.08,4.32,4.85,4.85,0,0,1-4.95,4.32A3.83,3.83,0,0,1,319.07,170.79Zm7.47,0a2.54,2.54,0,0,0-2.65-2.95,3.23,3.23,0,0,0-3.25,2.95,2.55,2.55,0,0,0,2.65,3A3.23,3.23,0,0,0,326.54,170.79Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M337.66,166.59l-.85,8.4h-1.28l-4.06-5.69L330.9,175h-1.55l.85-8.4h1.28l4.06,5.69.57-5.69Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M341.49,167.91H338.7l.14-1.32H346l-.13,1.32h-2.78l-.72,7.08h-1.56Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M351.79,175l-1.47-2.46H348.1l-.25,2.45h-1.56l.85-8.4h3.46c2.2,0,3.46,1.13,3.27,3a3.05,3.05,0,0,1-2.06,2.65l1.66,2.76Zm-1.4-7.08h-1.82l-.34,3.35h1.82c1.37,0,2.14-.63,2.25-1.68S351.76,167.91,350.39,167.91Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M360.71,173h-4.2l-1,2h-1.61l4.62-8.4H360L363,175h-1.63Zm-.39-1.22-1.22-3.67-1.94,3.67Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M363.76,170.79a4.83,4.83,0,0,1,4.93-4.32,3.83,3.83,0,0,1,3.18,1.4l-1.1.95a2.66,2.66,0,0,0-2.15-1,3.23,3.23,0,0,0-3.29,2.95,2.55,2.55,0,0,0,2.7,3,3.24,3.24,0,0,0,2.34-1l.91,1a4.71,4.71,0,0,1-3.47,1.41A3.81,3.81,0,0,1,363.76,170.79Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M375,167.91H372.2l.13-1.32h7.12l-.13,1.32h-2.78l-.72,7.08h-1.55Z" }),
				/* @__PURE__ */ _jsx("path", {
					d: "M305.67,186.79h-34a1,1,0,0,1,0-2h34a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M288.14,192.19h-17a1,1,0,0,1,0-2h17a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M409.91,220.42H268.32a1,1,0,0,1,0-2H409.91a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M409.29,226.59H267.69a1,1,0,0,1,0-2h141.6a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M408.67,232.75H267.07a1,1,0,0,1,0-2h141.6a1,1,0,1,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M408.05,238.91H266.45a1,1,0,0,1,0-2h141.6a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M407.42,245.07H265.83a1,1,0,0,1,0-2H407.42a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M406.8,251.24H265.21a1,1,0,0,1,0-2H406.8a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M406.18,257.4H264.59a1,1,0,0,1,0-2H406.18a1,1,0,1,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M405.56,263.56H264a1,1,0,0,1,0-2H405.56a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M334.94,269.72H263.35a1,1,0,0,1,0-2h71.59a1,1,0,1,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M414.35,186.79H389.93a1,1,0,0,1,0-2h24.42a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M404.16,278.08H277.64a1,1,0,0,1,0-2H404.16a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M403.48,284.24H261.88a1,1,0,0,1,0-2h141.6a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M402.86,290.41H261.26a1,1,0,0,1,0-2h141.6a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M402.23,296.57H260.64a1,1,0,0,1,0-2H402.23a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M401.61,302.73H260a1,1,0,0,1,0-2H401.61a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M311,308.9H259.4a1,1,0,0,1,0-2H311a1,1,0,0,1,0,2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("g", {
					style: {
						opacity: .2,
						isolation: "isolate"
					},
					children: /* @__PURE__ */ _jsx("polygon", { points: "403.85 409.68 237.08 409.68 265.35 129.19 432.12 129.19 403.85 409.68" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M376.86,401.21H210.09c30.62-90.22,49.12-181.8,53.26-272H430.12C426,219.41,407.48,311,376.86,401.21Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M417.11,157.8H270.94a.52.52,0,0,1-.51-.49.47.47,0,0,1,.49-.48H417.08a.51.51,0,0,1,.52.48A.48.48,0,0,1,417.11,157.8Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M289.54,145a8.45,8.45,0,0,1-8.44,7.67,7.21,7.21,0,0,1-7.41-7.67,8.39,8.39,0,0,1,8.38-7.66A7.26,7.26,0,0,1,289.54,145Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M277.06,143.81s-4,5.43-2.71,7.09,12.82-7.65,15.49-10.83-.59-1.91-.58-1.91,1.25.06.63,1.05c-1.26,2-12.2,9.17-13.37,8.79S277.06,143.81,277.06,143.81Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M416.32,142.39h-15a1,1,0,0,1-1.05-1,.94.94,0,0,1,1-1h15a1,1,0,0,1,1,1A.94.94,0,0,1,416.32,142.39Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M416,146.9h-9.69a1,1,0,0,1-1-1,.94.94,0,0,1,1-1H416a1,1,0,0,1,1,1A1,1,0,0,1,416,146.9Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M415.73,151.4H390.41a1,1,0,0,1-1-1,.93.93,0,0,1,1-1h25.31a1,1,0,0,1,1,1A.94.94,0,0,1,415.73,151.4Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", { d: "M309,169.41a4.68,4.68,0,0,1,4.86-4.18,4,4,0,0,1,3.2,1.36l-1.08.92a2.75,2.75,0,0,0-2.16-1,3.14,3.14,0,0,0-3.25,2.86,2.55,2.55,0,0,0,2.74,2.86,3.22,3.22,0,0,0,2.33-1l.92.93a4.71,4.71,0,0,1-3.46,1.36C310.53,173.59,308.78,171.84,309,169.41Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M317.54,169.41a4.71,4.71,0,0,1,4.89-4.18c2.6,0,4.37,1.76,4.15,4.18a4.71,4.71,0,0,1-4.9,4.18C319.08,173.59,317.33,171.82,317.54,169.41Zm7.47,0a2.55,2.55,0,0,0-2.7-2.86,3.14,3.14,0,0,0-3.2,2.86,2.54,2.54,0,0,0,2.69,2.86A3.15,3.15,0,0,0,325,169.41Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M336.06,165.35q-.35,4.07-.73,8.13h-1.28c-1.37-1.84-2.75-3.67-4.13-5.51-.16,1.84-.33,3.67-.5,5.51h-1.55q.39-4.06.73-8.13h1.28c1.39,1.83,2.77,3.67,4.15,5.5.16-1.83.33-3.67.48-5.5Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M339.91,166.62h-2.78c0-.42.07-.85.11-1.27h7.12c0,.42-.07.85-.11,1.27h-2.78c-.2,2.29-.4,4.57-.62,6.86h-1.56C339.51,171.19,339.71,168.91,339.91,166.62Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M350.31,173.48l-1.5-2.38h-2.22c-.07.79-.14,1.58-.22,2.37h-1.55q.38-4.06.72-8.13H349c2.2,0,3.48,1.09,3.32,2.89a2.92,2.92,0,0,1-2,2.57c.57.89,1.13,1.78,1.69,2.67Zm-1.5-6.86H347c-.09,1.08-.19,2.16-.28,3.24h1.82c1.37,0,2.13-.6,2.22-1.62S350.18,166.62,348.81,166.62Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M359.21,171.6H355l-1,1.88H352.4q2.27-4.06,4.5-8.13h1.54q1.55,4.07,3.06,8.13h-1.63Zm-.41-1.19c-.42-1.18-.84-2.37-1.27-3.55-.63,1.18-1.25,2.37-1.89,3.55Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M362.23,169.41a4.68,4.68,0,0,1,4.86-4.18,4,4,0,0,1,3.21,1.36c-.37.3-.73.61-1.09.92a2.75,2.75,0,0,0-2.16-1,3.14,3.14,0,0,0-3.25,2.86,2.55,2.55,0,0,0,2.74,2.86,3.22,3.22,0,0,0,2.33-1l.92.93a4.71,4.71,0,0,1-3.46,1.36C363.76,173.59,362,171.84,362.23,169.41Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M373.4,166.62h-2.78c0-.42.07-.85.11-1.27h7.12c0,.42-.07.85-.11,1.27H375c-.19,2.29-.4,4.57-.62,6.86h-1.55C373,171.19,373.21,168.91,373.4,166.62Z" }),
				/* @__PURE__ */ _jsx("path", {
					d: "M304.24,184.92h-34a1,1,0,1,1,0-1.94h34a1,1,0,1,1,0,1.94Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M286.68,190.16h-17a1,1,0,0,1-1-1,1,1,0,0,1,1-1h17a1,1,0,0,1,1,1A1,1,0,0,1,286.68,190.16Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M407.83,217.56H266.24a1,1,0,0,1-1-1,1,1,0,0,1,1-1H407.9a1,1,0,0,1,1,1A1,1,0,0,1,407.83,217.56Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M407,223.55H265.38a.93.93,0,0,1-1-1,1,1,0,0,1,1-1H407.05a.94.94,0,0,1,1,1A1,1,0,0,1,407,223.55Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M406.07,229.54H264.47a.94.94,0,0,1-1-1,1.05,1.05,0,0,1,1.05-1H406.16a1,1,0,0,1,1,1A1.06,1.06,0,0,1,406.07,229.54Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M405.13,235.53H263.53a.92.92,0,0,1-.94-1,1.06,1.06,0,0,1,1.05-1H405.23a.92.92,0,0,1,.95,1A1.06,1.06,0,0,1,405.13,235.53Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M404.15,241.52H262.56a.92.92,0,0,1-.94-1,1.06,1.06,0,0,1,1.06-1H404.27a.92.92,0,0,1,.94,1A1.07,1.07,0,0,1,404.15,241.52Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M403.13,247.51H261.54a.91.91,0,0,1-.93-1,1.07,1.07,0,0,1,1.06-1H403.26a.92.92,0,0,1,.94,1A1.08,1.08,0,0,1,403.13,247.51Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M402.08,253.5H260.48a.9.9,0,0,1-.92-1,1.08,1.08,0,0,1,1.07-1H402.22a.91.91,0,0,1,.93,1A1.08,1.08,0,0,1,402.08,253.5Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M401,259.49H259.39a.89.89,0,0,1-.92-1,1.09,1.09,0,0,1,1.08-1H401.14a.89.89,0,0,1,.92,1A1.08,1.08,0,0,1,401,259.49Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M329.85,265.48H258.26a.89.89,0,0,1-.92-1,1.09,1.09,0,0,1,1.09-1H330a.89.89,0,0,1,.92,1A1.1,1.1,0,0,1,329.85,265.48Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M412.92,184.92H388.5a1,1,0,1,1,0-1.94h24.42a1,1,0,1,1,0,1.94Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M398.32,273.61H271.8a.89.89,0,0,1-.91-1,1.11,1.11,0,0,1,1.1-1H398.5a.88.88,0,0,1,.91,1A1.11,1.11,0,0,1,398.32,273.61Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M397,279.6H255.44a.87.87,0,0,1-.9-1,1.11,1.11,0,0,1,1.1-1H397.23a.87.87,0,0,1,.9,1A1.12,1.12,0,0,1,397,279.6Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M395.77,285.59H254.18a.87.87,0,0,1-.9-1,1.14,1.14,0,0,1,1.11-1H396a.88.88,0,0,1,.9,1A1.14,1.14,0,0,1,395.77,285.59Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M394.47,291.58H252.88a.86.86,0,0,1-.89-1,1.14,1.14,0,0,1,1.11-1H394.7a.86.86,0,0,1,.88,1A1.14,1.14,0,0,1,394.47,291.58Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M393.13,297.57H251.54a.85.85,0,0,1-.88-1,1.15,1.15,0,0,1,1.12-1H393.37a.86.86,0,0,1,.88,1A1.14,1.14,0,0,1,393.13,297.57Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M301.76,303.56h-51.6a.85.85,0,0,1-.87-1,1.16,1.16,0,0,1,1.12-1H302a.85.85,0,0,1,.87,1A1.16,1.16,0,0,1,301.76,303.56Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("g", {
					style: { opacity: .1 },
					children: /* @__PURE__ */ _jsx("path", { d: "M376.86,401.21H210.09c30.62-90.22,49.12-181.8,53.26-272H430.12C426,219.41,407.48,311,376.86,401.21Z" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M354.22,383.55H187.45c38.46-84.36,63.92-170,75.9-254.36H430.12C418.14,213.55,392.68,299.19,354.22,383.55Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M415.62,155.94H269.46a.44.44,0,0,1-.47-.45.51.51,0,0,1,.52-.46H415.68a.44.44,0,0,1,.47.46A.51.51,0,0,1,415.62,155.94Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M289.17,143.94c-.63,3.95-4.73,7.16-9.11,7.16s-7.38-3.21-6.74-7.16,4.66-7.16,9-7.16S289.81,140,289.17,143.94Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M276.78,142.86s-4.5,5.08-3.32,6.63,13.49-7.15,16.43-10.13-.41-1.79-.41-1.79,1.25.07.54,1c-1.43,1.87-13,8.57-14.13,8.22S276.79,142.86,276.78,142.86Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M416.17,141.54h-15a.91.91,0,0,1-1-.91,1,1,0,0,1,1-.9h15a.89.89,0,0,1,1,.9A1,1,0,0,1,416.17,141.54Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M415.5,145.75h-9.69a.91.91,0,0,1-1-.91,1,1,0,0,1,1-.9h9.69a.89.89,0,0,1,1,.9A1,1,0,0,1,415.5,145.75Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M414.8,150H389.48a.9.9,0,0,1-1-.91,1,1,0,0,1,1.05-.9H414.9a.89.89,0,0,1,1,.9A1,1,0,0,1,414.8,150Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M256.88,369.43H205.7a.67.67,0,0,1-.7-.91,1.44,1.44,0,0,1,1.29-.9h51.18a.66.66,0,0,1,.7.9A1.43,1.43,0,0,1,256.88,369.43Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M348.78,369.43h-59a.67.67,0,0,1-.7-.91,1.44,1.44,0,0,1,1.29-.9h59.05a.67.67,0,0,1,.71.9A1.46,1.46,0,0,1,348.78,369.43Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M266.08,317.06H238.94a.71.71,0,0,1-.76-.9,1.32,1.32,0,0,1,1.24-.91h27.13a.71.71,0,0,1,.76.91A1.31,1.31,0,0,1,266.08,317.06Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M360.24,317.06H320.71a.71.71,0,0,1-.76-.9,1.32,1.32,0,0,1,1.24-.91h39.52a.71.71,0,0,1,.76.91A1.3,1.3,0,0,1,360.24,317.06Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M317.11,358.83a4.94,4.94,0,0,1-2.42-.51c-1.27-.74-1.58-2-.89-3.62a7.41,7.41,0,0,1,.34-.7,44.65,44.65,0,0,1-12,2.94c-2.46.15-3.06-.81-3.12-1.65-.12-1.49,1.34-3.86,3.67-6.61-5.4,2.42-9.36,3.89-9.44,3.92-.29.11-.55,0-.6-.22a.59.59,0,0,1,.43-.6c.09,0,4.8-1.79,10.94-4.61,6.24-6.79,16.62-15.15,22-18,3.87-2,6.12-2.61,6.7-1.66.9,1.5-3.52,6-10.81,10.88a125.8,125.8,0,0,1-17.32,9.44c-2.81,3.09-4.66,5.74-4.55,7.18,0,.3.1,1.19,2.3,1a45.45,45.45,0,0,0,12.6-3.21c3.12-4.22,10.37-9.2,13.69-10,1.28-.32,1.79,0,2,.34s.27.88-.43,1.78c-1.77,2.29-7.91,5.9-14.67,8.57a8.13,8.13,0,0,0-.74,1.32c-.53,1.26-.32,2.15.66,2.72,2.24,1.29,8-.55,13.72-3.19a3.55,3.55,0,0,1,.28-.9c1.6-3.64,9.42-9.28,13.58-9,.83,0,1,.41,1,.71.09,1.32-3.43,3.77-6.4,5.6a83.19,83.19,0,0,1-7.45,4c.14.49.63.8,1.47.94,6.19,1,20.66-8.05,20.79-8.14a.51.51,0,0,1,.69,0,.5.5,0,0,1-.24.64c-.6.38-15.06,9.44-21.68,8.34a2.25,2.25,0,0,1-2-1.37C324.78,357.23,320.19,358.83,317.11,358.83Zm25.35-13.54c-3.66,0-10.72,5.15-12.08,8.25,0,.09-.08.17-.11.26,2.49-1.21,4.9-2.53,6.94-3.79,4.28-2.63,5.83-4.23,5.8-4.61,0,0-.09-.08-.34-.1Zm-13.2-1.73a2.44,2.44,0,0,0-.62.1c-2.86.71-8.92,4.83-12.11,8.51,6-2.5,11.3-5.63,12.83-7.62.3-.39.4-.67.29-.85A.44.44,0,0,0,329.26,343.56ZM331.39,328c-.61,0-2.05.37-5,1.95-5.16,2.74-14.19,10.07-20.25,16.29a120.84,120.84,0,0,0,15.29-8.48c7.68-5.18,10.76-9,10.36-9.65C331.73,328,331.61,328,331.39,328Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", { d: "M306.5,166.8a5.15,5.15,0,0,1,5.23-3.91,3.73,3.73,0,0,1,3.08,1.27l-1.16.86a2.56,2.56,0,0,0-2.08-.89,3.45,3.45,0,0,0-3.5,2.67c-.29,1.56.75,2.67,2.49,2.67a3.68,3.68,0,0,0,2.42-.9l.84.87a5.35,5.35,0,0,1-3.58,1.27C307.67,170.71,306.07,169.07,306.5,166.8Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M315.05,166.8a5.16,5.16,0,0,1,5.24-3.91c2.61,0,4.22,1.65,3.8,3.91a5.19,5.19,0,0,1-5.27,3.91C316.22,170.71,314.62,169.05,315.05,166.8Zm7.47,0a2.21,2.21,0,0,0-2.45-2.67,3.43,3.43,0,0,0-3.45,2.67c-.3,1.55.75,2.67,2.44,2.67A3.45,3.45,0,0,0,322.52,166.8Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M333.92,163c-.47,2.53-.95,5.07-1.44,7.6H331.2l-3.65-5.15q-.48,2.58-1,5.15H325c.49-2.53,1-5.07,1.44-7.6h1.28q1.85,2.56,3.67,5.15l1-5.15Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M337.66,164.19h-2.78c.07-.4.14-.79.22-1.19h7.12c-.07.4-.15.79-.22,1.19h-2.78c-.4,2.14-.8,4.28-1.22,6.41h-1.55Q337.07,167.41,337.66,164.19Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M347.46,170.6l-1.29-2.23a1.77,1.77,0,0,1-.32,0H344l-.42,2.21H342c.49-2.53,1-5.07,1.43-7.6h3.45c2.21,0,3.39,1,3.08,2.7a3.14,3.14,0,0,1-2.24,2.4c.48.84,1,1.67,1.45,2.5Zm-.9-6.41h-1.82l-.57,3H346c1.37,0,2.19-.56,2.37-1.52S347.93,164.19,346.56,164.19Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M356.52,168.84h-4.2c-.38.59-.77,1.18-1.16,1.76h-1.61q2.63-3.79,5.21-7.6h1.54c.79,2.53,1.58,5.07,2.35,7.6H357C356.86,170,356.69,169.43,356.52,168.84Zm-.3-1.11-1-3.32c-.73,1.11-1.46,2.22-2.2,3.32Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M359.73,166.8a5.15,5.15,0,0,1,5.23-3.91,3.75,3.75,0,0,1,3.09,1.27l-1.17.86a2.56,2.56,0,0,0-2.08-.89,3.45,3.45,0,0,0-3.5,2.67c-.29,1.56.75,2.67,2.49,2.67a3.68,3.68,0,0,0,2.42-.9l.84.87a5.35,5.35,0,0,1-3.58,1.27C360.9,170.71,359.31,169.07,359.73,166.8Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M371.15,164.19h-2.78c.07-.4.14-.79.22-1.19h7.12c-.07.4-.14.79-.22,1.19h-2.78q-.6,3.21-1.21,6.41h-1.56C370.35,168.47,370.76,166.33,371.15,164.19Z" }),
				/* @__PURE__ */ _jsx("path", {
					d: "M300.39,181.3h-34a.86.86,0,0,1-.92-.91,1.08,1.08,0,0,1,1.09-.9h34a.85.85,0,0,1,.92.9A1.07,1.07,0,0,1,300.39,181.3Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M282.39,186.2h-17a.85.85,0,0,1-.91-.91,1.09,1.09,0,0,1,1.1-.9h17a.85.85,0,0,1,.91.9A1.09,1.09,0,0,1,282.39,186.2Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M401.15,211.82H259.56a.81.81,0,0,1-.88-.9,1.13,1.13,0,0,1,1.12-.91H401.39a.82.82,0,0,1,.88.91A1.12,1.12,0,0,1,401.15,211.82Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M399.77,217.42H258.18a.81.81,0,0,1-.88-.91,1.13,1.13,0,0,1,1.13-.9H400a.82.82,0,0,1,.88.9A1.14,1.14,0,0,1,399.77,217.42Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M398.35,223H256.75a.8.8,0,0,1-.86-.91,1.15,1.15,0,0,1,1.13-.91H398.61a.82.82,0,0,1,.87.91A1.14,1.14,0,0,1,398.35,223Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M396.89,228.62H255.29a.8.8,0,0,1-.86-.91,1.16,1.16,0,0,1,1.14-.9H397.16a.79.79,0,0,1,.86.9A1.14,1.14,0,0,1,396.89,228.62Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M395.39,234.22H253.79a.79.79,0,0,1-.85-.91,1.16,1.16,0,0,1,1.14-.9h141.6a.79.79,0,0,1,.85.9A1.15,1.15,0,0,1,395.39,234.22Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M393.85,239.83H252.26a.79.79,0,0,1-.85-.91,1.16,1.16,0,0,1,1.15-.91H394.15a.79.79,0,0,1,.85.91A1.18,1.18,0,0,1,393.85,239.83Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M392.27,245.43H250.68a.78.78,0,0,1-.84-.91,1.18,1.18,0,0,1,1.15-.91h141.6a.78.78,0,0,1,.84.91A1.2,1.2,0,0,1,392.27,245.43Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M390.66,251H249.06a.78.78,0,0,1-.83-.91,1.2,1.2,0,0,1,1.16-.91H391a.78.78,0,0,1,.84.91A1.2,1.2,0,0,1,390.66,251Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M319,256.63h-71.6a.77.77,0,0,1-.83-.91,1.22,1.22,0,0,1,1.17-.91h71.59a.78.78,0,0,1,.84.91A1.21,1.21,0,0,1,319,256.63Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M409.07,181.3H384.66a.86.86,0,0,1-.92-.91,1.08,1.08,0,0,1,1.09-.9h24.42a.85.85,0,0,1,.91.9A1.07,1.07,0,0,1,409.07,181.3Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M386.77,264.23H260.25a.76.76,0,0,1-.82-.91,1.21,1.21,0,0,1,1.17-.91H387.12a.76.76,0,0,1,.82.91A1.21,1.21,0,0,1,386.77,264.23Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M385,269.83H243.37a.76.76,0,0,1-.82-.91,1.23,1.23,0,0,1,1.18-.91h141.6a.75.75,0,0,1,.81.91A1.23,1.23,0,0,1,385,269.83Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M383.18,275.43H241.58a.75.75,0,0,1-.81-.91,1.24,1.24,0,0,1,1.19-.9h141.6a.75.75,0,0,1,.81.9A1.24,1.24,0,0,1,383.18,275.43Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M381.36,281H239.76a.75.75,0,0,1-.8-.91,1.25,1.25,0,0,1,1.2-.91H381.75a.74.74,0,0,1,.8.91A1.26,1.26,0,0,1,381.36,281Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M379.5,286.64H237.91a.75.75,0,0,1-.8-.91,1.25,1.25,0,0,1,1.2-.91h141.6a.73.73,0,0,1,.79.91A1.26,1.26,0,0,1,379.5,286.64Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M287.6,292.24H236a.74.74,0,0,1-.79-.91,1.27,1.27,0,0,1,1.21-.91H288a.73.73,0,0,1,.79.91A1.27,1.27,0,0,1,287.6,292.24Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsxs("g", {
					style: { opacity: .2 },
					children: [
						/* @__PURE__ */ _jsx("path", { d: "M282.23,337.13c.51-.45,1.79-1.44,2.55-2,.34-.26.77-.29,1-.06.43.52.86,1,1.28,1.57,0,0-1.42,1.59-1.88,2.13-4.6,5.45-7.35,10.69-7,11.69,4.7-.48,35.41-15.51,49.16-24.34-3.05-6.38-10.31-10.36-20.2-9.91-14.08.64-29.2,10.47-35.69,22.95a25.71,25.71,0,0,0-3.2,12.47A123,123,0,0,1,282.23,337.13Z" }),
						/* @__PURE__ */ _jsx("path", { d: "M273.1,362.8c3.37,3.13,8.38,5,14.68,5,15.73,0,33.57-11.53,39.32-25.79a21.93,21.93,0,0,0,1.66-10.9C314.67,341.15,287.31,357.6,273.1,362.8Z" }),
						/* @__PURE__ */ _jsx("path", { d: "M283.51,338.12c.05,0-20.68,18.28-17.92,23.85,2.93,5.58,55.09-25.72,68-36.49,13.09-10.74,0-6.45,0-6.44s4.44.22,1.15,3.54c-6.59,6.78-54.07,30.93-57.88,29.64S283.54,338.13,283.51,338.12Z" })
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M220.07,360.7c-7.35,0-8.82-2.85-8.75-5.31.25-7.28,14.45-19.73,29.25-25.62,8.13-3.23,14.61-3.44,16.52-.52,1.56,2.41-.36,6.39-5.32,10.93-9.8,9-17.9,11-21.48,9.06a3.31,3.31,0,0,1-1.24-1.12c-.9.42-1.89.86-3,1.31a.43.43,0,0,1-.62-.19.58.58,0,0,1,.4-.61c1.05-.45,2-.87,2.85-1.27a3.7,3.7,0,0,1,.68-2.89A7,7,0,0,1,235,341.4c.94.05,1.49.47,1.46,1.13-.06,1.3-2.3,3.07-6.39,5.1a2.6,2.6,0,0,0,.92.8c2.43,1.32,9.47,1,20.13-8.78,4.56-4.18,6.38-7.76,5-9.81-1.66-2.55-7.84-2.25-15.37.74-14.39,5.72-28.19,17.68-28.43,24.59-.1,3.21,3,4.81,8.94,4.61,7.62-.24,15.67-3.35,22.44-7,2.14-4.1,8.37-9.42,15-12.61,1.32-.64,2.08-.78,2.43-.46s.22.67-.16,1.25c-1.38,2.12-7.93,7.6-16.44,12.24-.11.24-.21.48-.29.7a2.43,2.43,0,0,0,.5,2.9c2.82,2.34,13.07-4.63,16.74-7.52a.55.55,0,0,1,.72,0c.16.16.09.45-.15.64-.55.45-14.15,11-18.13,7.65-1-.82-1.21-2.08-.67-3.64-6.87,3.61-14.84,6.56-22.21,6.79Zm40.17-20.24a5.93,5.93,0,0,0-1.23.48c-5.71,2.76-11.28,7.31-13.73,11a77.32,77.32,0,0,0,12-8.34A13.33,13.33,0,0,0,260.24,340.46Zm-25.68,1.84a5.66,5.66,0,0,0-4.28,2.45,2.86,2.86,0,0,0-.54,2.12c4.34-2.15,5.66-3.57,5.68-4.14,0-.35-.51-.41-.74-.42Z",
					style: { fill: "#8A6BD6" }
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "freepik--Character--inject-40",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "freepik--group--inject-40",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M184.58,177.11S166.15,158.88,144,157.75c0,0-13.18,31.92-19.57,63.58l43.89,7.82S174.39,196.3,184.58,177.11Z",
						style: { fill: "#8A6BD6" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M184.58,177.11c-10.19,19.19-16.22,52-16.22,52l-43.89-7.82a328.51,328.51,0,0,1,8.83-33.49c2.4-7.61,4.76-14.32,6.65-19.47,2.43-6.6,4.09-10.62,4.09-10.62C166.15,158.88,184.58,177.11,184.58,177.11Z",
						style: {
							fill: "#fff",
							opacity: .6000000000000001,
							isolation: "isolate"
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M175.08,158.89c-.45.43-.9.88-1.31,1.35l-.22.26a10.1,10.1,0,0,0-2,3.39,5.9,5.9,0,0,0-.28,1.67,7.23,7.23,0,0,0,2.49,5.18c-.08,2.2-5.76.06-5.76.06s-8.35-4.46-9.41-9.53c3.21-.66,6.12-4.23,8.41-8.18.58-1,1.12-2,1.62-3.05.86-1.76,1.58-3.48,2.13-4.91Z",
						style: { fill: "#e4897b" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M173.77,160.24l-.22.26a10.1,10.1,0,0,0-2,3.39,5.9,5.9,0,0,0-.28,1.67c-2.45-2.33-5.57-6.73-4.27-12.47a14.5,14.5,0,0,1,1.34-3.6l.28.55Z",
						style: {
							opacity: .2,
							isolation: "isolate"
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M196.1,140.11s-2.39,11-9.46,12.95.33-17.53.33-17.53Z",
						style: { fill: "#263238" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M167.39,155.23a10.12,10.12,0,0,0,9.48,7.82,11.58,11.58,0,0,0,8.78-3.42c5.15-5.34,10.27-16.17,5.12-22.93a11,11,0,0,0-18.64,1.77C168.46,145.61,166,149.64,167.39,155.23Z",
						style: { fill: "#e4897b" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M181.49,146.59a1,1,0,0,0,.06,1.42c.38.22.94-.07,1.27-.63s.3-1.2-.06-1.41S181.83,146,181.49,146.59Z",
						style: { fill: "#263238" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M187.85,150.35a1,1,0,0,0,.07,1.41c.37.22.94-.07,1.27-.63s.3-1.19-.07-1.41S188.17,149.82,187.85,150.35Z",
						style: { fill: "#263238" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M185.67,149.43a23.34,23.34,0,0,0-.16,6.41,3.77,3.77,0,0,1-3-1.09Z",
						style: { fill: "#de5753" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M191.82,149a.39.39,0,0,1-.34-.21,3.1,3.1,0,0,0-2.21-1.67.39.39,0,0,1-.35-.42.38.38,0,0,1,.42-.34h0a3.78,3.78,0,0,1,2.81,2.08.38.38,0,0,1-.14.52h0A.58.58,0,0,1,191.82,149Z",
						style: { fill: "#263238" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M181.73,143.3a.35.35,0,0,1-.15-.17.39.39,0,0,1,.31-.45h0a3.81,3.81,0,0,1,3.36,1,.37.37,0,0,1,0,.54h0a.39.39,0,0,1-.54,0h0a3.11,3.11,0,0,0-2.68-.73A.38.38,0,0,1,181.73,143.3Z",
						style: { fill: "#263238" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M182.3,132.83,181,136.16a2.65,2.65,0,0,0-2.73,2.32c-.38,3.17-4,6.47-6.9,7,0,0,.53-1.17-.57-1.41s-4,5.84-3.59,9.67c0,0-1.49-4.06.2-11.15,1.56-6.55,3.91-11.45,6.27-13.06Z",
						style: { fill: "#263238" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M165.76,142.35a7.66,7.66,0,0,0,1.81,5.56c1.75,2,4.11.81,4.86-1.62.65-2.16.56-5.88-1.81-7S166,139.88,165.76,142.35Z",
						style: { fill: "#e4897b" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M181,156.28a21.35,21.35,0,0,0-2.34,1.95l-.43-.32c-1.93-1.48-2.34-2.81-2.21-3.83a3.07,3.07,0,0,1,.56-1.37,2.91,2.91,0,0,1,.57-.63,11.55,11.55,0,0,0,3.2,3.68C180.76,156.09,181,156.28,181,156.28Z",
						style: { fill: "#263238" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M180.37,155.76l-.7.56c-1.82-1.4-2.92-2.62-3.07-3.61a2.91,2.91,0,0,1,.57-.63A11.55,11.55,0,0,0,180.37,155.76Z",
						style: { fill: "#fff" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M178.25,157.91c-1.93-1.48-2.34-2.81-2.21-3.83a7.83,7.83,0,0,1,1.82,2.07A2.86,2.86,0,0,1,178.25,157.91Z",
						style: { fill: "#de5753" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M181,136.16s14.41,12,16.79.12c0,0-6.92-8.71-15.29-10.24s-10.87,6.8-10.87,6.8Z",
						style: { fill: "#263238" }
					}),
					/* @__PURE__ */ _jsx("path", { d: "M129.07,410.19H118.94a.75.75,0,0,0-.72.58l-1.64,7.43a1.24,1.24,0,0,0,1,1.46l.27,0c3.28-.05,5.67-.25,9.78-.25,2.54,0,10.19.26,13.7.26s3.95-3.46,2.52-3.78c-6.43-1.4-11.27-3.34-13.33-5.19A2,2,0,0,0,129.07,410.19Z" }),
					/* @__PURE__ */ _jsx("path", { d: "M172.05,409.93H161.92a.73.73,0,0,0-.71.57l-1.65,7.43a1.25,1.25,0,0,0,1.22,1.49c3.28-.06,5.67-.26,9.79-.26,2.53,0,10.19.27,13.69.27s4-3.46,2.52-3.78c-6.43-1.4-11.27-3.34-13.33-5.19A2,2,0,0,0,172.05,409.93Z" }),
					/* @__PURE__ */ _jsx("path", {
						d: "M124.47,217.73l44.93,6.72c.52,2.81-.72,8.6-.72,8.6,5.21,34.09,15.53,114.48,7.23,178.11h-15s1.39-110.1-11.85-145.67c-1.52,19-17,145.59-17,145.59H116.81s2.28-47.6,4.57-92.57c1.2-23.75-1.26-72.6,1-90Z",
						style: { fill: "#263238" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M149.08,265.49A118.93,118.93,0,0,1,154,284.65c1.24-16.95-3.71-34.92-3.71-34.92Z",
						style: {
							opacity: .2,
							isolation: "isolate"
						}
					}),
					/* @__PURE__ */ _jsx("polygon", { points: "136.76 226.11 162.15 229.93 162.79 224.89 137.5 221.12 136.76 226.11" }),
					/* @__PURE__ */ _jsx("polygon", { points: "135.35 220.79 123.8 219.07 122.85 224.02 134.67 225.79 135.35 220.79" }),
					/* @__PURE__ */ _jsx("polygon", { points: "164.78 225.19 163.85 230.18 168.78 230.92 169.4 225.88 164.78 225.19" }),
					/* @__PURE__ */ _jsx("path", {
						d: "M155.34,223.8a2.35,2.35,0,0,0-1.45-.93l-4-.7a1.69,1.69,0,0,0-2,1.54l-.29,2.6a2.46,2.46,0,0,0,1.76,2.55l.17,0,4,.69a1.69,1.69,0,0,0,2-1.54l.29-2.59A2.37,2.37,0,0,0,155.34,223.8Zm-1.81,4.73-4-.7a1,1,0,0,1-.7-.44,1.16,1.16,0,0,1-.24-.81l.29-2.6a.82.82,0,0,1,1-.74l4,.7H154a1.21,1.21,0,0,1,.62.43,1.15,1.15,0,0,1,.23.81l-.05.39a.67.67,0,0,0-.15-.06l-1.12-.21a.6.6,0,0,0-.71.58.84.84,0,0,0,.66.83l1.12.21h.06l-.1.85A.83.83,0,0,1,153.53,228.53Z",
						style: { fill: "#fff" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M161.26,168.37l1.53,7.42s-3.44,18.71,1.06,36l4.34,2.54,2.37-3.44s-6.72-16.91-5.15-33.73l4-5.46Z",
						style: { fill: "#263238" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M162,159.49l4.26,10,5.31-5.61,3.73,5.85a10.53,10.53,0,0,1-3.71,7.5l-5.5-5.53-8.38,1s-2.61-8.66-2-10.89S162,159.49,162,159.49Z",
						style: { fill: "#8A6BD6" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M133.3,187.84c2.4-7.61,4.76-14.32,6.65-19.47l2.78-1.24S146.11,177.93,133.3,187.84Z",
						style: {
							opacity: .2,
							isolation: "isolate"
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M162,159.49l4.26,10,5.31-5.61,3.73,5.85a10.53,10.53,0,0,1-3.71,7.5l-5.5-5.53-8.38,1s-2.61-8.66-2-10.89S162,159.49,162,159.49Z",
						style: {
							fill: "#fff",
							opacity: .4,
							isolation: "isolate"
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M144,157.75c-5.92-.29-17.89,13.82-20.92,16.33s-11.35,2.13-16.25-2.35c0,0-3.76-.75-5.38,1.82,0,0,8,11.4,19.24,10.16s18.58-12,18.58-12a24.64,24.64,0,0,0,4.73-7.28C145.64,160.36,144,157.75,144,157.75Z",
						style: { fill: "#8A6BD6" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M144,157.75c-5.92-.29-17.89,13.82-20.92,16.33s-11.35,2.13-16.25-2.35c0,0-3.76-.75-5.38,1.82,0,0,8,11.4,19.24,10.16s18.58-12,18.58-12a24.64,24.64,0,0,0,4.73-7.28C145.64,160.36,144,157.75,144,157.75Z",
						style: {
							fill: "#fff",
							opacity: .6000000000000001,
							isolation: "isolate"
						}
					}),
					/* @__PURE__ */ _jsx("polygon", {
						points: "246.87 298.5 247.7 300.48 245.76 299.57 238.5 292.06 239.61 290.99 246.87 298.5",
						style: { fill: "#263238" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M83.25,121.65h4.87A1.38,1.38,0,0,1,89.5,123v21.13a0,0,0,0,1,0,0H81.87a0,0,0,0,1,0,0V123a1.38,1.38,0,0,1,1.38-1.38Z",
						transform: "matrix(0.72, -0.7, 0.7, 0.72, -68.3, 96.92)",
						style: { fill: "#263238" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M83.25,121.65h4.87A1.38,1.38,0,0,1,89.5,123v21.13a0,0,0,0,1,0,0H81.87a0,0,0,0,1,0,0V123a1.38,1.38,0,0,1,1.38-1.38Z",
						transform: "matrix(0.72, -0.7, 0.7, 0.72, -68.3, 96.92)",
						style: {
							fill: "#fff",
							opacity: .1,
							isolation: "isolate"
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M93.68,133.7l-7.47,7.22a3.59,3.59,0,0,0-.17,5q66.15,73.47,137.51,142h0s10.39,8.42,20.48,10.57l1.85-1.78c-1.82-10.16-9.88-20.82-9.88-20.82h0Q169.94,202.36,98.66,133.69A3.59,3.59,0,0,0,93.68,133.7Z",
						style: { fill: "#8A6BD6" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M97.05,126.7l-12.6,12.18a1.06,1.06,0,0,0,0,1.51l1.22,1.27,12.81-12.39c19.35,18.21,33.93,34.87,33.93,34.87l-.5,1.36,4.56,2.77c-3.81-8.58-32.41-36.45-37.71-41.57A1.2,1.2,0,0,0,97.05,126.7Z",
						style: { fill: "#263238" }
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 147.01,
						y: 205.26,
						width: 21.2,
						height: 4.07,
						transform: "translate(-99.79 167.83) rotate(-44.03)",
						style: { fill: "#8A6BD6" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M174.4,240.87q20.7,20.89,41.76,41.3a1.64,1.64,0,0,0,2.29,0l12-11.55a1.64,1.64,0,0,0,.07-2.29q-19.64-21.72-39.87-43.12a1.65,1.65,0,0,0-2.35-.05l-13.82,13.36A1.66,1.66,0,0,0,174.4,240.87Z",
						style: { fill: "#263238" }
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 147.01,
						y: 205.26,
						width: 21.2,
						height: 4.07,
						transform: "translate(-99.79 167.83) rotate(-44.03)",
						style: {
							opacity: .2,
							isolation: "isolate"
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M97.05,126.7l-12.6,12.18a1.06,1.06,0,0,0,0,1.51l1.22,1.27,12.81-12.39c19.35,18.21,33.93,34.87,33.93,34.87l-.5,1.36,4.56,2.77c-3.81-8.58-32.41-36.45-37.71-41.57A1.2,1.2,0,0,0,97.05,126.7Z",
						style: {
							fill: "#fff",
							opacity: .6000000000000001,
							isolation: "isolate"
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M174.4,240.87q20.7,20.89,41.76,41.3a1.64,1.64,0,0,0,2.29,0l12-11.55a1.64,1.64,0,0,0,.07-2.29q-19.64-21.72-39.87-43.12a1.65,1.65,0,0,0-2.35-.05l-13.82,13.36A1.66,1.66,0,0,0,174.4,240.87Z",
						style: {
							fill: "#fff",
							opacity: .1,
							isolation: "isolate"
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M195.43,222.58l-1.17,1.57a4.54,4.54,0,0,0-3.61.64s.1,4,.27,4.5c.36,1.16,5.57,4.62,6.92,4.8.42.06,1.22-2.72,1.09-3.67a16.57,16.57,0,0,0-1.78-3.61l1-1.4Z",
						style: { fill: "#e4897b" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M106.93,173.75l.16-1.26s.85.21,1.21-1.25,1.09-5.06.58-5.94a45.38,45.38,0,0,0-4.48-5c-.74-.64-2.47,2.4-2.86,3.81s1.57,6.88,1.57,6.88l-.08,2.37A4.45,4.45,0,0,0,106.93,173.75Z",
						style: { fill: "#e4897b" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M184.58,177.11c2.87,3.28,11.89,16.59,14.37,23.08,3.46,9.1,0,27.4,0,27.4l-6-4s1.13-13.93-.42-18.88-13.71-14.24-13.71-14.24A24,24,0,0,1,180.6,184,27.44,27.44,0,0,1,184.58,177.11Z",
						style: { fill: "#8A6BD6" }
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M199,227.59l-6-4s1.13-13.93-.42-18.88c-.88-2.8-5.17-7-8.72-10.11-2.71-2.38-5-4.13-5-4.13a23.59,23.59,0,0,1,1.63-6l.19-.45a27.44,27.44,0,0,1,4-6.84c2.87,3.28,11.89,16.59,14.37,23.08C202.41,209.29,199,227.59,199,227.59Z",
						style: {
							fill: "#fff",
							opacity: .6000000000000001,
							isolation: "isolate"
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M183.77,194.56c-2.71-2.38-5-4.13-5-4.13a23.59,23.59,0,0,1,1.63-6A19.73,19.73,0,0,1,183.77,194.56Z",
						style: {
							opacity: .2,
							isolation: "isolate"
						}
					})
				]
			})
		})
	]
});
export default SvgNoContracts;
